import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';

import { useMobile } from '../../hooks/useMobile';
import { useTheme } from '../../hooks/useTheme';

import './adaptive-modal.scss';

export const AdaptiveModal = ({
  open,
  onOpen,
  contentStyle,
  background = 'background-modal',
  mobileAutoHeight = false,
  mobilePadded = false,
  mobileFlush = false,
  mobileFullHeight = false,
  closeDisabled = false,
  children
}) => {
  const { getThemeVariable } = useTheme();
  const isMobile = useMobile();

  const [isMounted, setIsMounted] = useState(open);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let timeout;

    if (open) {
      setIsMounted(true); // mount immediately
      timeout = setTimeout(() => setIsVisible(true), 20); // animate in
    } else {
      setIsVisible(false); // animate out
      timeout = setTimeout(() => setIsMounted(false), 500); // unmount after animation
    }

    return () => clearTimeout(timeout);
  }, [open]);

  if (isMobile) {
    return isMounted ? (
      <div className="adaptive-modal--mobile">
        {/* Overlay fades */}
        <div
          className={`adaptive-modal__overlay ${isVisible ? 'adaptive-modal__overlay--visible' : ''}`}
          onClick={() => !closeDisabled && onOpen(false)}
        />

        {/* Content slides */}
        <div
          className={[
            'adaptive-modal__content',
            isVisible && 'adaptive-modal__content--visible',
            mobileAutoHeight && 'adaptive-modal__content--auto',
            mobilePadded && 'adaptive-modal__content--padded',
            mobileFlush && 'adaptive-modal__content--flush',
            mobileFullHeight && 'adaptive-modal__content--full'
          ]
            .filter(Boolean)
            .join(' ')}
          style={{ background: getThemeVariable(background) }}
        >
          {children}
        </div>
      </div>
    ) : null;
  }

  return (
    <Modal
      isOpen={open}
      onRequestClose={() => !closeDisabled && onOpen(false)}
      shouldCloseOnOverlayClick={!closeDisabled}
      shouldCloseOnEsc={!closeDisabled}
      style={{
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          padding: '20px',
          borderRadius: isMobile ? '4px 4px 0 0' : '4px',
          background: getThemeVariable(background),
          border: 'none',
          ...contentStyle
        },
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          zIndex: 9999
        }
      }}
    >
      {children}
    </Modal>
  );
};
